// Route Code Edited 09/22/2026
(function () {
try {
    customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__routeOutsideClickPatched) return;
    var original = CartDrawer.prototype.hideForOutsideClickTarget;
    if (typeof original !== 'function') return;
    CartDrawer.prototype.hideForOutsideClickTarget = function (target) {
        try {
        if (target && target.closest && target.closest('.route-modal')) return false;
        } catch (e) {}
        return original.call(this, target);
    };
    CartDrawer.prototype.__routeOutsideClickPatched = true;
    }).catch(function () {});
} catch (e) {}
})();
// End Route Code